module.exports = __webpack_public_path__ + "static/img/lounge-thumb.8b45e5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/lounge-thumb.jpg
// module id = Tjdz
// module chunks = 0